import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../_metronic/_helpers";
import { useSubheader } from "../../_metronic/layout";
import { Link, useHistory } from "react-router-dom";
import { baseURLV1,KEY } from "../service/API.js";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import paginationFactory from "react-bootstrap-table2-paginator";
import Pagination2 from "@material-ui/lab/Pagination";
import { useSelector } from "react-redux";
import TextField from '@material-ui/core/TextField'


export const CancelCoupon = () => {
  const suhbeader = useSubheader();
  const allData = [];
  const [Banner, setBannerData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalSize, setTotalSize] = useState(100);
  const [openImage, setOpenImage] = useState(false)
  const [imgSelect, setImgSelect] = useState('')
  const [rotation, setRotation] = useState(0)
  const [id, setId] = useState('')
  const [access, setAccess] = useState([]);
  const [relate_product_check, setRelateProductCheck] = useState(false)
  var d = new Date()
  d.setDate(d.getDate() - 30)
  const [dateFrom, setDateFrom] = useState(moment(d).format('YYYY-MM-DD'))
  const [dateTo, setDateTo] = useState(moment(new Date()).format('YYYY-MM-DD'))
  suhbeader.setTitle("Cancel Coupon management");
  const { authToken, accessTokenPrivilege } = useSelector((state) => state.auth);
  const history = useHistory();
  useEffect(() => {
    getData(1, 10, search);
    //getPermission()

  }, []);


  const handleChangeDateFrom = date => {
    setDateFrom(date)
  }
  const handleChangeDateTo = date => {
    setDateTo(date)
  }
  const getData = async (page, limit, search) => {
    setPage(page);
    axios({
      method: "get",
      url: `${baseURLV1}/order?page=${page}&limit=${limit}&orderType=adjusted${search !== undefined && search !== "" ? "&search=" + search : ""
        }&date_from=${dateFrom}&date_to=${dateTo}`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    }).then((res) => {
      if (res.message) {
        history.push("/logout");
      } else {
        console.log(res.data)

        res.data.data.map((data, index) => {
          /*data = {
            id: data.id,
            title_th: data.title_th,
            title_en: data.title_en,
            description_th: data.description_th,
            description_en: data.description_en,
            start_date: data.start_date,
            end_date: data.end_date,
            point: data.point,
            quota_member: data.quota_member,
            quota_period: data.quota_period,
            is_active: data.is_active,
            code: data.code,
          };*/
          allData.push(data);
        });
      }
      var totalpage = Math.ceil(res.data.total / res.data.limit);
      setTotalPage(totalpage);
      setTotalSize(res.data.total);
      setLimit(res.data.limit);
      setBannerData(allData);
      console.log(allData)
    });
  };
  const convertDate = (date, formatDate) => {
    const dates = new Date(date)
    const result = dates.toLocaleDateString(formatDate, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })

    return result
  }
  const convertDate2 = (date, formatDate) => {
    const dates = new Date(date)
    const result = dates.toLocaleDateString(formatDate, {
      year: 'numeric',
      month: 'long',
      //day: 'numeric',
    })

    return result
  }
  const columns = [
    // {
    //   dataField: "id",
    //   text: "ID",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    // },
    {
      dataField: "affiliateOrderNumber",
      text: "Order",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '220px' }}>
            <p>{row.affiliateOrderNumber}</p>
          </div>
        );
      },
    },
    {
      dataField: "accountCode",
      text: "account Code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '160px' }}>
            <p>{row.accountCode}</p>
          </div>
        );
      },
    },
    {
      dataField: "orderType",
      text: "order type",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '160px' }}>
            <p>{row.orderType}</p>
          </div>
        );
      },
    },
    
    {
      dataField: "orderDate",
      text: "Adjust Period",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '140px' }}>
            <p>{row.orderDate ? convertDate2(row.orderDate, 'th-TH') : '-'}</p>
          </div>
        );
      },
    },
    {
      dataField: "created_at",
      text: "Adjust Date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '160px' }}>
            <p>{row.created_at ? convertDate(row.created_at, 'th-TH') : '-'}</p>
          </div>
        );
      },
    },
    {
      dataField: "aHappyAmount",
      text: "Adjust Amount",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '170px' }}>
            <p>{row.aHappyAmount}</p>
          </div>
        );
      },
    },

    /*{
      text: "Action",
      dataField: "id",
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{width:'150px'}}>
            <button
              type="button"
              className="btn btn-primary mr-2"
              onClick={() => editItem({ id, row, rowIndex })}
            >
              Edit
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={() => deleteItem({ row, rowIndex })}
            >
              Delete
            </button>

          </div>
        );
      },
    },*/
  ];

  const rotate = () => {
    let newRotation = Number(rotation) + 90
    if (newRotation >= 360) {
      newRotation = -360
    }
    setRotation(newRotation)
  }


  const editItem = (data) => {
    history.push("/EditQRcode", data);
  };

  const deleteItem = (data) => {
    console.log(data)
    Swal.fire({
      title: "ยืนยันการลบรายการ?",
      text: "รายการนี้จะถูกลบออก !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "ลบ!",
      cancelButtonText: "ไม่ลบ",
    }).then((result) => {
      if (result.value) {
        axios
          .delete(`${baseURLV1}/qrcode/${data.row.id}`)
          .then((res) => {
            Swal.fire("ทำรายการสำเร็จ!", "", "success");
            getData(1, limit, search);
          })
          .catch((err) => {
            Swal.fire(
              "ทำรายการไม่สำเร็จ!",
              "",
              "error"
            );
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("ยกเลิกการทำรายการ", "", "error");
      }
    });
  };
  const [search, setSearch] = useState();
  const handleSearch = () => {
    setPage(1);
    getData(1, limit, search);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getData(value, limit, search);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    getData(1, event.target.value, search);
  };

  const handleClose = () => {
    setId('')
    setOpenImage(false)
    setImgSelect('')
    setRelateProductCheck(false)
  }

  return (
    <Card>
      <CardHeader title="Cancel Coupon management">
        <CardHeaderToolbar>
          {access.includes("BACKOFFICE_CREATE_ADJUST") && <Link to="/CreateAdjustUser">
            <button type="button" className="btn btn-primary">
              + Create
            </button>
          </Link>}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="row form-inline mb-2">
          <div className="col-lg-3 col-md-3 col-sm-3">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Text Search"
                style={{ width: "100%" }}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="mr-3">
            <div className="form-group">
              <button
                type="button"
                id="button"
                className="btn btn-primary"
                style={{ width: "100%" }}
                onClick={() => handleSearch()}
              >
                Search
              </button>
            </div>
          </div>
          <div>
            <TextField
              id="DateFrom"
              type="date"
              label="Date From"
              defaultValue={dateFrom}
              className=" mb-3 mr-3"
              style={{
                height: '38px',
                width: '185px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              InputLabelProps={{
                shrink: true
              }}
              onChange={name => {
                handleChangeDateFrom(name.target.value)
              }}
            />
          </div>

          <div>
            <TextField
              id="DateFrom"
              type="date"
              label="Date To"
              defaultValue={dateTo}
              className=" mb-3 mr-3"
              style={{
                height: '38px',
                width: '185px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              InputLabelProps={{
                shrink: true
              }}
              onChange={name => {
                handleChangeDateTo(name.target.value)
              }}
            />
          </div>


        </div>


        <BootstrapTable
          keyField="id"
          data={Banner}
          columns={columns}
          wrapperClasses="table-responsive table-cm"
          bordered={false}
          classes="header-table table table-head-custom table-vertical-center overflow-hidden table-fixed"
          bootstrap4
        />
        <div className=" col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <div className="mt-3">
                {"Items per Page: "}
                <select onChange={handlePageSizeChange} value={limit}>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
            </div>
            <div className="col-lg-6">
              <Pagination2
                className="mt-3 "
                count={totalPage}
                page={page}
                siblingCount={1}
                boundaryCount={1}
                variant="outlined"
                shape="rounded"
                onChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
